<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-layout wrap>
      <v-flex v-if="$can('read','admin_report')">
        <material-card
          title='Pharmacies Report' color='success'>
            <core-field
              type='autocomplete'
              @input:field='v => protocolPharma = v.selectedItem'
              :field="protocolField"
              :value='protocolPharma && protocolPharma.id'
            />
            <v-btn color='success' large class='white--text' :loading="loadingPharmaciesReport"
              :disabled='!protocolPharma || loadingPharmaciesReport'
              @click='reportPharma(protocolPharma)'>
              <v-icon>mdi-file-excel</v-icon>
              Download .xls
            </v-btn>
        </material-card>
      </v-flex>
      <v-flex xs12 sm6 md6 xl4 v-if="$can('read','stock_report')">
        <material-card
          title='Stock Report' color='success'>
            <core-field
              type='autocomplete'
              @input:field='v => protocolStock = v.selectedItem'
              :field="protocolField"
              :value='protocolStock && protocolStock.id'
            />
            <v-btn color='success' large class='white--text' :loading="loadingStockReport"
              :disabled='!protocolStock || loadingStockReport'
              @click='reportStock(protocolStock)'>
              <v-icon>mdi-file-excel</v-icon>
              Download .xls
            </v-btn>          
        </material-card>
      </v-flex>
      <!-- <v-flex v-if="$can('read','admin_report')">
        <material-card
          title='Total Stock Report' color='success'>
            <core-field
              type='autocomplete'
              @input:field='v => protocolGiacenzeTotali = v.selectedItem'
              :field="protocolField"
              :value='protocolGiacenzeTotali && protocolGiacenzeTotali.id'
            />
            <v-btn color='success'
              :disabled='!protocolGiacenzeTotali'
              large class='white--text' @click='reportGiacenzeTotali(protocolGiacenzeTotali)'>
              <v-icon>mdi-file-excel</v-icon>
              Download .xls
            </v-btn>
        </material-card>
      </v-flex> -->
      <v-flex v-if="$can('read','user_report')">
        <material-card
          title='User Report' color='success'>
            <v-btn color='success' large class='white--text'
              @click='reportUsers' :disabled="loadingUserReport" :loading="loadingUserReport">
              <v-icon>mdi-file-excel</v-icon>
              Download Users.xls
            </v-btn><br/>
            <v-btn color='success' large class='white--text'
              @click='reportProtocolSiteUsers' :disabled="loadingUserProtocolSiteReport" :loading="loadingUserProtocolSiteReport">
              <v-icon>mdi-file-excel</v-icon>
              Download Users Protocol Site .xls
            </v-btn>
        </material-card>
      </v-flex>
      <v-flex xs12 sm6 md6 xl4 v-if="$can('read','monitor_report')">
        <material-card
          title='Monitor Report' color='success'>
            <core-field
              type='autocomplete'
              @input:field='v => protocolMonitor = v.selectedItem'
              :field="protocolField"
              :value='protocolMonitor && protocolMonitor.id'
            />
            <core-field
              type='autocomplete'
              :item='monitorItem'
              :readonly="!protocolMonitor"
              @input:field='v => siteMonitor = v.selectedItem'
              :field="siteField"
              v-model="monitorItem['site_id']"
            />            
            <v-btn color='success'
              :loading='loadingMonitorReport'
              :disabled='!protocolMonitor || loadingMonitorReport'
              large class='white--text' @click='reportMonitor'>
              <v-icon>mdi-file-excel</v-icon>
              Download .xls
            </v-btn>
        </material-card>
      </v-flex>
      <v-flex xs12 sm6 md6 xl4 v-if="$can('read','site_report') && role === 'Site'">
        <material-card
          title='Site Report' color='success'>
            <core-field
              type='autocomplete'
              @input:field='v => protocolMonitor = v.selectedItem'
              :field="protocolField"
              :item='monitorItem'
              v-model='monitorItem["protocol_id"]'
            />
            <v-btn color='success'
              :loading='loadingMonitorReport'
              :disabled='!protocolMonitor || loadingMonitorReport'
              large class='white--text' @click='reportSite'>
              <v-icon>mdi-file-excel</v-icon>
              Download .xls
            </v-btn>
        </material-card>
      </v-flex>      
    </v-layout>


  </v-container>
</template>

<script>
import { reportPharma, reportStock,
  reportUsers, reportMonitor, reportSite, reportProtocolSiteUsers } from '@/api/report'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      // reportPharma,
      // reportGiacenze,
      // reportUsers,
      // reportProtocolSiteUsers,
      protocolField: {
        full: true,
        value: 'protocol_id',
        text: 'Protocol',
        filter: () => ({ status: '!=CANCELED' }),
        type: 'autocomplete',
        title: 'name'
      },
      siteField: {
        full: true,
        value: 'site_id',
        id: 'site_id',
        subtitle: 'site.city',
        reference: 'protocol_has_site',
        text: 'Site',
        type: 'autocomplete',
        title: 'site.name',
        filter: (item, search) => {
                if (!search) {
                    return  { protocol_id: item.protocol_id }
                }
                return { protocol_id: item.protocol_id, 'site.name': [{ 'site.name': `%${search}%`},
                    {'site.city': `%${search}%`}, {'site.code': `%${search}%`}]}
            },
        deps: ['protocol_id'],
      },
      protocolPharma: {},
      protocolStock: {},
      monitorItem: {}, 
      protocolMonitor: {},
      siteMonitor: {},
      loadingMonitorReport: false,
      loadingUserReport: false,
      loadingUserProtocolSiteReport: false,
      loadingPharmaciesReport: false,
      loadingStockReport: false
    }
  },
  created () {
    if (this.protocol.id !== -1) {
      this.protocolMonitor = this.protocolStock = this.protocolPharma = this.protocol
    } else {
      this.protocolMonitor = this.protocolStock = this.protocolPharma = null
    }
  },
  methods: {
    async reportMonitor () {
      this.loadingMonitorReport = true
      try {
        await reportMonitor(this.protocolMonitor, this.monitorItem.site_id && this.siteMonitor.site)
      } catch (e) {
        console.error(e.response.data.message)
        this.$root.$emit('openSnackbar', {
            message: `An error occurred: ${e.response.data.message || e}`,
            color: 'warning'
          })        
      }
      this.loadingMonitorReport = false
    },
    async reportStock () {
      this.loadingStockReport = true
      await reportStock(this.protocolStock)
      this.loadingStockReport = false
    },
    async reportPharma () {
      this.loadingPharmaciesReport = true
      await reportPharma(this.protocolPharma)
      this.loadingPharmaciesReport = false
    },
    async reportUsers () {
      this.loadingUserReport = true
      await reportUsers()
      this.loadingUserReport = false
    },
    async reportProtocolSiteUsers () {
      this.loadingUserProtocolSiteReport = true
      await reportProtocolSiteUsers()
      this.loadingUserProtocolSiteReport = false
    },    
    async reportSite () {
      this.loadingMonitorReport = true
      await reportSite(this.protocolMonitor)
      this.loadingMonitorReport = false      
    }
  },
  watch: {
    protocol () {
      if (this.protocol.id !== -1) {
        this.protocolMonitor = this.protocolStock = this.protocolPharma = this.protocol
      } else {
        this.protocolMonitor = this.protocolStock = this.protocolPharma = null
      }
    }
  },
  computed: {
    ...mapState('app', ['protocol']),
    ...mapState('user', ['role'])
  }
}
</script>
